import React,{useEffect,useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import './assest/style/style.css';
import AOS from "aos";
import "aos/dist/aos.css";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import { DataProvider } from './components/DataContext';

import Home from './components/Home';
import HowWillThisHelpYou from './components/HowWillThisHelpYou'
import EnjoyTheRide from "./components/EnjoyTheRide";
import CoffeeRules from "./components/CoffeeRules"
import Instructions from "./components/Instructions";
import ChooseASimulation from "./components/ChooseASimulation"
import PersonalizeSimulationHome from "./components/PersonalizeSimulation/PersonalizeSimulationHome";
import NumOfRentalProperty from "./components/PersonalizeSimulation/NumOfRentalProperty";
import MortgageInformation from "./components/PersonalizeSimulation/MortgageInformation";
import LendingMoney from "./components/LendingMoney/LendingMoney";
import PersonalizeSimulationDecisionMaking from "./components/PersonalizeSimulation/PersonalizeSimulationDecisionMaking";
import InvestingInRealEstateHome from "./components/RealState/InvestingInRealEstateHome";
import InvestRealState1 from "./components/RealState/InvestRealState1";
import InvestRealState2 from "./components/RealState/InvestRealState2";
import InvestRealState3 from "./components/RealState/InvestRealState3";
import InvestRealState4 from "./components/RealState/InvestRealState4";
import InvestRealState5 from "./components/RealState/InvestRealState5";
import InvestRealState6 from "./components/RealState/InvestRealState6";
import InvestRealState7 from "./components/RealState/InvestRealState7";
import InvestRealState8 from "./components/RealState/InvestRealState8";
import InvestingInRealEstateDecisionMaking from "./components/RealState/InvestingInRealEstateDecisionMaking";
import InvestRealState10 from "./components/RealState/InvestRealState10";
import WhatWastheBetterDecision from "./components/RealState/WhatWastheBetterDecision";

function App() {

  {/* Real State */}
  const [propertiesData, setPropertiesData] = useState({});
  const [loanInformation , setLoanInformation] = useState({});
  {/* Personalize Simulation */}
  const [mortgageInformation, setMortgageInformation] = useState({});
  const [rentalProperty , setRentalProperty] = useState({});

  useEffect(() => { 
    AOS.init({
      offset: 100,
      duration: 800,
      easing: 'ease-in-out',
      delay: 200,
      anchorPlacement: 'center-bottom'
    });
  }, [])

  return (
    <>
    <BrowserView>
      <BrowserRouter>
      <DataProvider>
          <Routes>
            <Route exact path="/" element={<Home />} />
            <Route exact path="/how-will-this-help-you" element={<HowWillThisHelpYou />} />
            <Route exact path="/enjoy-the-ride" element={<EnjoyTheRide />} />
            <Route exact path="/coffee-rules" element={<CoffeeRules />} />
            <Route exact path="/instructions" element={<Instructions />} />
            <Route exact path="/choose-a-simulation" element={<ChooseASimulation />} />

            {/* Real State */}
            <Route exact path="/investing-in-real-estate" element={<InvestingInRealEstateHome />} />
            <Route exact path="/investing-in-real-estate/first-step" element={<InvestRealState1 />} />
            <Route exact path="/investing-in-real-estate/second-step" element={<InvestRealState2 />} />
            <Route exact path="/investing-in-real-estate/third-step" element={<InvestRealState3 />} />
            <Route exact path="/investing-in-real-estate/fourth-step" element={<InvestRealState4 />} />
            <Route exact path="/investing-in-real-estate/fifth-step" element={<InvestRealState5 onPropertiesDataDataChange={setPropertiesData}/>} />
            <Route exact path="/investing-in-real-estate/sixth-step" element={<InvestRealState6 onLoanInformationDataChange={setLoanInformation}/>} />
            <Route exact path="/investing-in-real-estate/seventh-step" element={<InvestRealState7 />} />
            <Route exact path="/investing-in-real-estate/eighth-step" element={<InvestRealState8 />} />
            <Route exact path="/investing-in-real-estate/decision-making/:dbg?" element={ <InvestingInRealEstateDecisionMaking  
                                                                                    propertiesData={propertiesData}
                                                                                    loanInformation={loanInformation}/>
                                                                                  }/>
            <Route exact path="/investing-in-real-estate/what-was-the-better-decision" element={<InvestRealState10 />} />
            

            {/* Personalize Simulation */}
            <Route exact path="/personalize-simulation" element={<PersonalizeSimulationHome />} />
            
            <Route exact path="/personalize-simulation/number-of-rental-property" element={<NumOfRentalProperty/>} />
            <Route exact path="/personalize-simulation/mortgage-information" element={<MortgageInformation/>} />
            <Route exact path="/personalize-simulation/personalize-simulation-decision-making" element={<PersonalizeSimulationDecisionMaking/>}/>
            <Route exact path="/personalize-simulation/what-was-the-better-decision" element={<WhatWastheBetterDecision />} />  
            
            {/* Lending Money */}
            <Route exact path="/lending-money" element={<LendingMoney />} />

            <Route path="*" element={<Home />} />
          </Routes>
          </DataProvider>
      </BrowserRouter>
    </BrowserView>
    <MobileView>
    <div className="bg bg-home bg-center">
      <div className="container d-flex flex-column align-items-center justify-content-center vh-100">
            <div className="row d-flex justify-content-center align-items-center my-auto text-center w-100">
                <div className="bg-light py-3 mt-8">
                    <div className="col-12 heading-font h1 display-2">Notice</div>
                    <p className="text-danger heading-font display-6">Mobile Device Compatibility Unavailable</p>
                </div>
            </div>
        </div>
      </div>
    </MobileView>
    </>
  );
}

export default App;